import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSettings } from '../contexts/SettingsContext';

const Navbar = () => {
    const location = useLocation();
    const { blurNsfw, setBlurNsfw, onlyNsfw, setOnlyNsfw } = useSettings();
    const isActive = (path) => location.pathname === path;

    const navItems = [
        { path: '/files', label: 'Local', icon: <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" /> },
        { path: '/files/all', label: 'Combined', icon: <path d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 14a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 14a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /> },
        { path: '/files/remote', label: 'Remote', icon: <path d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" /> },
    ];

    return (
        <nav className="bg-white border-b border-gray-200 shadow-sm">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex justify-between h-16">
                    <div className="flex">
                        <Link to="/files" className="flex-shrink-0 flex items-center">
                            <span className="text-base sm:text-xl font-bold text-blue-600">Misskey FileView</span>
                        </Link>
                        <div className="hidden lg:-my-px lg:ml-8 lg:flex lg:space-x-8">
                            {navItems.map((item) => (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={`${
                                        isActive(item.path)
                                            ? 'border-blue-500 text-gray-900'
                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    } inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`}
                                >
                                    <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        {item.icon}
                                    </svg>
                                    {item.label}
                                </Link>
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => setOnlyNsfw(!onlyNsfw)}
                            className={`hidden lg:flex items-center space-x-1 px-3 py-1.5 rounded-full text-xs font-bold transition-all border ${
                                onlyNsfw 
                                    ? 'bg-red-50 text-red-600 border-red-200 shadow-sm' 
                                    : 'text-gray-400 border-transparent hover:bg-gray-100'
                            }`}
                            title={onlyNsfw ? "Show All Files" : "Show NSFW Only"}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                            <span>NSFW Only</span>
                        </button>
                        <div className="w-px h-6 bg-gray-200 mx-1"></div>
                        <button
                            onClick={() => setBlurNsfw(!blurNsfw)}
                            className={`p-2 rounded-full transition-colors ${blurNsfw ? 'text-amber-500 bg-amber-50 hover:bg-amber-100' : 'text-gray-400 hover:bg-gray-100'}`}
                            title={blurNsfw ? "Disable NSFW Blur" : "Enable NSFW Blur"}
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                        </button>
                        <button 
                            onClick={() => { localStorage.removeItem('authToken'); window.location.href = '/login'; }}
                            className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
            {/* Mobile Nav */}
            <div className="lg:hidden flex justify-around border-t border-gray-100 bg-gray-50 py-2">
                {navItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`${
                            isActive(item.path) ? 'text-blue-600' : 'text-gray-500'
                        } flex flex-col items-center text-xs`}
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {item.icon}
                        </svg>
                        {item.label}
                    </Link>
                ))}
                <button
                    onClick={() => setOnlyNsfw(!onlyNsfw)}
                    className={`${onlyNsfw ? 'text-red-600 font-bold' : 'text-gray-500'} flex flex-col items-center text-xs`}
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    NSFW
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
